import { h, Fragment } from 'preact';
import Icons from '../../../components/Icons/Icons';
import Typography from '../../../components/Typography/Typography';

/**
 * ArticleShare component renders a section for sharing an article
 * through various social media platforms and email.
 *
 * @param {Object} props - The component props.
 * @param {Function} props.handleOnClick - Callback function triggered when a share button is clicked.
 *                                          It receives the name of the platform as an argument.
 *
 * @returns {JSX.Element} The rendered ArticleShare component.
 */

export const ArticleShare = ({ handleOnClick }) => {
  return (
    <div>
      <Typography
        content="Share article"
        desktopfontsize="tw:md:text-base"
        mobilefontsize="tw:text-sm"
        classname="tw:md:mb-4 tw:mb-3"
      />

      <div className="tw:flex tw:space-x-4">
        <button
          className="tw:cursor-pointer tw:transition-opacity tw:hover:opacity-70"
          onClick={() => handleOnClick('facebook')}
        >
          <Icons.facebookReverse />
        </button>
        <button
          className="tw:cursor-pointer tw:transition-opacity tw:hover:opacity-70"
          onClick={() => handleOnClick('twitter')}
        >
          <Icons.twitterReverse />
        </button>
        <button
          className="tw:cursor-pointer tw:transition-opacity tw:hover:opacity-70"
          onClick={() => handleOnClick('linkedin')}
        >
          <Icons.linkedinReverse />
        </button>
        <button
          className="tw:cursor-pointer tw:transition-opacity tw:hover:opacity-70"
          onClick={() => handleOnClick('whatsapp')}
        >
          <Icons.whatsappReverse />
        </button>
        <button
          className="tw:cursor-pointer tw:transition-opacity tw:hover:opacity-70"
          onClick={() => handleOnClick('mail')}
        >
          <Icons.mail />
        </button>
      </div>
    </div>
  );
};
